import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// Preserve old bookmarks and the notes alias without losing page state in the URL.
export default function NoLiRedirect({ page }) {
  const { pathname, search, hash } = useLocation();
  let destination = page
    ? `/dashboard/noli/${page}`
    : pathname.replace(/^\/dashboard\/scavenger(?=\/|$)/, "/dashboard/noli");

  if (/^\/dashboard\/noli\/?$/.test(destination)) {
    destination = "/dashboard/noli/nutrition";
  } else if (/^\/dashboard\/noli\/notes\/?$/.test(destination)) {
    destination = "/dashboard/noli/life";
  }

  return <Navigate to={{ pathname: destination, search, hash }} replace />;
}
